<template>
  <div class="tablewrap">
    <table class="ptable">
      <thead>
        <tr>
          <th>Assembly BOM</th>
          <th class="act" />
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td
            colspan="2"
            class="statecell">
            <v-progress-circular
              indeterminate
              color="secondary"
              size="28" />
          </td>
        </tr>
        <tr v-else-if="!items.length">
          <td colspan="2">
            <div class="emptylines">
              <v-icon
                size="34"
                color="#a1a1aa">
                mdi-package-variant-closed
              </v-icon>
              <div>ไม่พบรายการ</div>
            </div>
          </td>
        </tr>
        <tr
          v-for="(item, i) in items"
          v-else
          :key="i"
          class="ptable__row"
          :class="{ 'is-selected': isSelected(item) }">
          <td>
            <div class="tprod__inner">
              <img
                :src="$convertImgix(`${item.imageURL}`) || noPicture"
                class="tthumb"
                :class="{ 'tthumb--clickable': item.imageURL }"
                alt="bom-image"
                @click="onPreview(item.imageURL)">
              <div class="tprod__meta">
                <div class="tprod__code">
                  {{ item.parentItemNo }}
                </div>
                <div class="tprod__desc">
                  {{ item.description || '-' }}
                </div>
              </div>
            </div>
          </td>
          <td class="act">
            <v-icon
              v-if="isSelected(item)"
              size="18"
              color="#a1a1aa">
              mdi-check
            </v-icon>
            <v-btn
              v-else
              icon
              small
              color="secondary"
              :disabled="loading || disabled"
              @click="onSelect(item)">
              <v-icon size="18">
                mdi-plus
              </v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import NoPicture from '@/assets/image/no_picture_available.png'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Function,
      default: () => () => false
    }
  },
  data () {
    return {
      noPicture: NoPicture
    }
  },
  methods: {
    onSelect (item) {
      this.$emit('select', item)
    },
    onPreview (url) {
      if (url) {
        this.$emit('preview', url)
      }
    }
  }
}
</script>

<style scoped>
.tablewrap {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  overflow: auto;
  height: 100%;
}
.ptable {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 360px;
}
.ptable thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--surface-2);
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--muted);
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
  white-space: nowrap;
}
.ptable th.act,
.ptable td.act {
  width: 64px;
  text-align: center;
}
.ptable__row td {
  padding: 6px 12px;
  border-bottom: 1px solid var(--line);
  vertical-align: middle;
}
.ptable__row:hover td {
  background: var(--surface-2);
}
.ptable__row.is-selected td {
  background: var(--surface-3);
}
.tprod__inner {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tthumb {
  width: 40px;
  height: 40px;
  border-radius: var(--r-sm);
  object-fit: cover;
  background: var(--surface-3);
  border: 1px solid var(--line);
  flex: none;
}
.tthumb--clickable {
  cursor: pointer;
}
.tprod__meta {
  min-width: 0;
}
.tprod__code {
  font-weight: 600;
  color: var(--ink);
}
.tprod__desc {
  font-size: 12px;
  color: var(--muted);
}
.statecell {
  padding: 40px 12px !important;
  text-align: center;
}
.emptylines {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--muted);
  font-size: 14px;
  padding: 32px 16px;
}
</style>
